import AuthService from './authService.js';
import ClientPricingHistoryItem from '../Domain/ClientPricingHistoryItem';
import ClientPricingHistoryTotalItem from '../Domain/ClientPricingHistoryTotalItem';

// Client "Pricing History" tab (CD-5650): year, invoiced evaluations and client fee over a client's history.
// The numbers are computed by ClientPricingHistory_Micro behind the monolith's ClientPricingHistoryController.
class ClientPricingHistoryService {
  // True when the client (or a client below it) has a won opportunity and a completed, billable shop - the
  // condition that makes the tab available. Resolves false, never rejects, so a failed check just means the
  // tab stays hidden instead of breaking the client detail.
  static GetAvailability(clientId) {
    return AuthService.getInstance()
      .CallBackendFunction(`/api/ClientPricingHistory/GetAvailability?clientId=${clientId}&clearCache=false`)
      .then((available) => available === true)
      .catch(() => false);
  }

  // Grid rows, per-currency totals and filter lists. `request` carries PascalCase keys, as the other
  // monolith posts do: { ClientId, IncludeChildClients, Currency, Dimensions, Filters, SortBy, SortDescending }.
  static GetPricingHistory(request) {
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/ClientPricingHistory/GetPricingHistory',
      JSON.stringify(request)
    );
  }

  // Only the filter lists, for a draft selection in the filter pop-up that is not applied yet.
  static GetFilterOptions(request) {
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/ClientPricingHistory/GetFilterOptions',
      JSON.stringify(request)
    );
  }

  static ConvertDBItems(rows) {
    return rows.map((row) => new ClientPricingHistoryItem(row));
  }

  static ConvertDBTotalItems(totals) {
    return totals.map((total) => new ClientPricingHistoryTotalItem(total));
  }
}

export default ClientPricingHistoryService;
